import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { RetailService } from '../../_service/retail.service';
import { LeadsService } from '../../_service/leads.service';
import { CorporateService } from '../../_service/corporate.service';
import { SharedService } from '../../_service/shared.service';
import { UserService } from '../../_service/user.service';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
declare var $: any;
@Component({
  selector: 'app-retail-insurance-leads-sheetview',
  templateUrl: './retail-insurance-leads-sheetview.component.html',
  styleUrls: ['./retail-insurance-leads-sheetview.component.css']
})
export class RetailInsuranceLeadsSheetviewComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUpload', {static: false}) csvUpload: ElementRef;
  private hotRegisterer = new HotTableRegisterer();settings = {colHeaders: true };hideColumn:any;loaded:boolean=false;perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;id = 'hotInstance';userId:string;status:number;pmode='';
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;myrole:string;corporate_lead_status=[];retail_leads=[];search:string;submitted = false;submitted_file=false;sheetCircle=[];bds=[];corporate_lead_status_list=[];circles=[];circle='';bds_list=[];bd:string;treatments=[];treatment='';s3url:string='';upload_msg:string='';payment_mode_drop=['Cash','Reimbursement'];start_date:string='';end_date:string='';
  constructor(private sharedapi:SharedService, private userapi:UserService, private retailapi:RetailService,private corporateapi:CorporateService,private leadapi:LeadsService) { }

  ngOnInit(): void {
    this.loadCommonData();
    this.getCorporateStatusLists();
    this.getcircle();this.getbds();
    this.getTreatment();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.s3url = localStorage.getItem('s3url');
    this.myrole = localStorage.getItem('role');
  }

  ngAfterViewInit() {
    this.getRetailLeads(0,25);
  }

  async getbds(status=1)
  {
    this.leadapi.getbdsofCorporate(status).subscribe((data:any) => {
        if(data.status)
        {
            this.bds_list = data.data;
        }else{
            this.bds_list = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
          this.getRetailLeads(0,this.perpage);
      }
  }
  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
      this.getRetailLeads(0,this.perpage);
  }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.data;
          }else{
              this.treatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getCorporateStatusLists()
  {
    await this.corporateapi.getCorporateStatusLists().subscribe((data:any) => {
      if(data.status)
      {
        this.corporate_lead_status_list = data.data;
      }
      else
      {
        this.corporate_lead_status_list = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getRetailLeads(pageIndex,perpage)
  {
    this.paginator.pageIndex = pageIndex;
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    this.loading = true;this.loaded = false;
    let qString = 'search='+this.search+'&status='+this.status+'&circle='+this.circle+'&bd='+this.bd+'&treatment='+this.treatment+'&payment_mode='+this.pmode+'&date_range='+this.start_date+'-'+this.end_date;
    this.retailapi.getRetailLeadsForsheetview(pageIndex,perpage,qString).subscribe((data:any) => {
        this.length = parseInt(data.totaldata);
        this.loading = false;
        this.loaded = true;
        if(data.status)
        {
            this.retail_leads = data.data;
              if(this.myrole=='6' || this.myrole=='18'){
                this.hideColumn = {columns: [5],indicators: true};
              }
        }else{
            this.retail_leads = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async loadCommonData()
  {
    await this.corporateapi.getCommonData().subscribe((data:any) => {
        if(data.status)
        {
            this.bds = data.bd;
            this.sheetCircle = data.circle; 
            this.corporate_lead_status = data.lead_status;
        }else{
          this.bds = [];
          this.sheetCircle = []; 
          this.corporate_lead_status = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.getRetailLeads(event.pageIndex,event.pageSize);
  }

  onBeforeChange = (hotInstance, changes) =>
  {
      let data= this.hotRegisterer.getInstance(this.id).getSourceData();
      let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3]};
      if(saveData.new_value) {
        this.saveOnChange(saveData);
      }else{
        this.sharedapi.presentToast('This field will not be blank');
      }
      
  }

  async saveOnChange(saveData)
  {
      this.submitted = true;
      await this.retailapi.UpdateRetailLeadsFromSheetview(saveData).subscribe((data:any) =>
      {
          this.submitted = false;
          this.sharedapi.presentToast(data.msg);
      }, error => {
              this.sharedapi.checkError(error);
      });

  }

  hideModal()
  {
    /* $('#myModal').modal('hide'); */
    window.location.reload();
  }

  showModal()
  {
      $('#myModal').modal();
  }

  async selectFile(event)
  {
      this.submitted_file = true;
      this.upload_msg = '';
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.leadapi.uploadcsvRetail(formData)
      .subscribe((data:any) => {
          this.submitted_file = false;
          this.csvUpload.nativeElement.value = "";
          if(data.status)
          {
              /* this.hideModal(); */
              this.upload_msg = data.full_msg;
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
            this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }
}
